<nz-form-control *ngIf="recordProperty !== undefined && !field.AdditionalInformationParsed.SelectOptionsAsCards">
  <select *ngIf="!global.useNZSelectInLines && !field.AdditionalInformationParsed.IsMultiple
    && (section.Type === 2 && section.XmlTagName === 'Document_Lines')" [class]="parentClass"
    (change)="selectValueChanged();" (focus)="getOptions(field)" [(ngModel)]="value"
    [disabled]="recordProperty.ReadOnly" [ngStyle]="{ width: width !== 0 ? width + 'px' : null, 'max-width': '100%' }">
    <option></option>
    <option *ngFor="let option of recordProperty.Options" [ngValue]="option.Code.toString()">
      {{ field.AdditionalInformationParsed.OptionsToBeTranslated ? (option.Name | locale) : option.Name }}
    </option>
  </select>
  <nz-select [class]="parentClass" *ngIf="!field.AdditionalInformationParsed.IsMultiple
      && (!((section.Type === 2 && section.XmlTagName === 'Document_Lines' )) || global.useNZSelectInLines)"
    [nzShowSearch]="
      field.AdditionalInformationParsed.EnableSearch == null ||
      field.AdditionalInformationParsed.EnableSearch === true
    " (nzOpenChange)="getOptions(field)" [nzAllowClear]="!field.Required" [(ngModel)]="value" [compareWith]="compareFn"
    [nzDisabled]="recordProperty.ReadOnly" [nzShowArrow]="false"
    [ngStyle]="{ width: width !== 0 ? width + 'px' : null }">
    <ng-container *ngFor="let option of recordProperty.Options">
      <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()" [nzLabel]="
          field.AdditionalInformationParsed.OptionsToBeTranslated
            ? (option.Name | locale)
            : option.Name
        "></nz-option>
    </ng-container>
    <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
      <i nz-icon nzType="loading" class="loading-icon"></i>
      {{ "Loading ..." | locale }}
    </nz-option>
  </nz-select>
  <nz-select [class]="parentClass" *ngIf="field.AdditionalInformationParsed.IsMultiple" [nzMode]="'multiple'"
    [nzShowSearch]="
      field.AdditionalInformationParsed.EnableSearch == null ||
      field.AdditionalInformationParsed.EnableSearch === true
    " (nzOpenChange)="getOptions(field)" [nzAllowClear]="!field.Required" [(ngModel)]="recordProperty.ValueAsObjectArr"
    (ngModelChange)="selectValueChanged();" [compareWith]="compareFn" [nzDisabled]="recordProperty.ReadOnly"
    [nzShowArrow]="false" [ngStyle]="{ width: width !== 0 ? width + 'px' : null }">
    <ng-container *ngFor="let option of recordProperty.Options">
      <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()" [nzLabel]="
          field.AdditionalInformationParsed.OptionsToBeTranslated
            ? (option.Name | locale)
            : option.Name
        "></nz-option>
    </ng-container>
    <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
      <i nz-icon nzType="loading" class="loading-icon"></i>
      {{ "Loading ..." | locale }}
    </nz-option>
  </nz-select>
</nz-form-control>

<nz-form-control *ngIf="recordProperty !== undefined && field.AdditionalInformationParsed.SelectOptionsAsCards">
  <nz-row>
    <nz-col style="padding-right: 5px;padding-bottom: 5px;" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="6" [nzXl]="3"
      *ngFor="let option of recordProperty.Options" (click)="value = option.Code?.toString()">
      <nz-card nzHoverable [ngClass]="{
      'card-selected': (value === option.Code?.toString())
    }">
        <div [innerHtml]="option.Name | safeHtml">
        </div>
      </nz-card>
    </nz-col>
  </nz-row>
</nz-form-control>
